import { groq } from "hydrogen-sanity/groq";

export const BASE_LINK = groq`
        ...,
        type == "internal" && defined(reference) =>{
            reference -> _type == "page" => {
                reference -> slug.current != '/' =>{
                    "slug": '/' + reference -> slug.current
                },
                reference -> slug.current == '/' =>{
                    "slug": reference -> slug.current
                }
            },
            reference -> _type != "page" => {
            "slug": '/' + reference -> _type + '/' + reference -> slug.current
            },
        },
        type == "external"  && defined(url)=>{
            "slug":  url
        }
`;

export const LINK = groq`
    link {
        ${BASE_LINK},
        reference ->{
            ...
        }
    }
`;

export const IMAGE = groq`
    image {
        ...,
        asset -> {
            ...
        }
    }
`;

export const CONTENT = groq`
    content[]{
        ...,
        asset -> {
        ...
        }
    }
`;

/** Icon field from Sanity icons schema (string: domain, volunteer_activism, etc.) */
export const ICONS = groq`icon`;
